import React from 'react';
import Head from 'next/head';

import { preConnect } from '../script';

export interface GoogleMapsScriptProps {
  apiKey?: string;
}

export const GoogleMapsScript = (props: GoogleMapsScriptProps): JSX.Element => {
  const apiKey = props.apiKey || process.env.NEXT_PUBLIC_GOOGLE_API_KEY;
  return (
    <Head>
      {preConnect('https://maps.googleapis.com')}
      {/* Async scripts get added twice due to SSR. Only add on client side. */}
      {apiKey && (
        <script
          src={`https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=en&region=US`}
          type="text/javascript"
          defer
        />
      )}
    </Head>
  );
};

export default GoogleMapsScript;
